import { getLatestCompletedQuarterRange } from '@koda/koda-utils/date';
import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { DancePayload } from './types/payloads';

// Dance School business information schema (updated to match latest design)
// Validation messages use i18n keys under licenses.steps.businessInformation.forms.danceSchool
export const DANCE_SCHOOL_CONTENT_PATH = 'licenses.steps.businessInformation.forms.danceSchool';

export const danceSchoolSchema = BasicBusinessInformationSchema.extend({
  lessonsQuarterly: z
    .number({
      required_error: `${DANCE_SCHOOL_CONTENT_PATH}.lessonsQuarterly.validation.required`,
    })
    .int({ message: `${DANCE_SCHOOL_CONTENT_PATH}.lessonsQuarterly.validation.required` })
    .min(1, { message: `${DANCE_SCHOOL_CONTENT_PATH}.lessonsQuarterly.validation.required` }),
  averageStudentsPerLesson: z
    .number({
      required_error: `${DANCE_SCHOOL_CONTENT_PATH}.averageStudentsPerLesson.validation.required`,
    })
    .int({ message: `${DANCE_SCHOOL_CONTENT_PATH}.averageStudentsPerLesson.validation.required` })
    .min(1, { message: `${DANCE_SCHOOL_CONTENT_PATH}.averageStudentsPerLesson.validation.required` }),
  eventsQuarterly: z
    .number()
    .int({ message: `${DANCE_SCHOOL_CONTENT_PATH}.eventsQuarterly.validation.numeric` })
    .min(0, { message: `${DANCE_SCHOOL_CONTENT_PATH}.eventsQuarterly.validation.minimum` })
    .optional(),
});

export type DanceSchoolForm = z.infer<typeof danceSchoolSchema>;

export const createDanceSchoolDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.DanceSchool,
});

export const toPayloadDanceSchool = (form: DanceSchoolForm): DancePayload => {
  const { start } = getLatestCompletedQuarterRange();
  return {
    musicStartDate: dayjs(start).format('YYYY-MM-DD'),
    participants: form.averageStudentsPerLesson ?? 0,
    arrangements: form.eventsQuarterly ?? 0,
    quantity: form.lessonsQuarterly ?? 0,
  };
};
